// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ThemeSettings from './components/settings';
import { ChartStyle } from './components/chart';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import { LicenseInfo } from '@mui/x-license';
import { ErrorBoundary } from 'react-error-boundary';
import './assets/css/styles.css';
import ErrorScreen from './components/ErrorScreen';
// env
import { env } from './config/env';

// Import the VideoCallProvider
import { VideoCallProvider } from './contexts/VideoCallContext';
import { VideoCallLogProvider } from './contexts/VideoCallLogContext';

// Import ActingRoleProvider
import { ActingRoleProvider } from './contexts/ActingRoleContext';
import ActingRoleDialog from './dialogs/user/ActingRoleDialog';

// Cache busting
import CacheBuster from 'react-cache-buster';
import packageJson from '../package.json';

// Location Detection
import { LocationDetectionProvider } from './contexts/LocationDetectionContext';
import ConversationsProvider from './contexts/ConversationsContext';

LicenseInfo.setLicenseKey(env.muiLicenseKey);

const isProduction = process.env.NODE_ENV === 'production';

// ----------------------------------------------------------------------

export default function App() {
    return (
        <CacheBuster
            currentVersion={packageJson.version}
            isEnabled={isProduction}
            isVerboseMode={false}
        >
            <MotionLazyContainer>
                <ThemeProvider>
                    <ThemeSettings>
                        <NotistackProvider>
                            <LocationDetectionProvider>
                                <VideoCallLogProvider>
                                    <VideoCallProvider>
                                        <ConversationsProvider>
                                            <ActingRoleProvider>
                                                <ErrorBoundary
                                                    fallbackRender={({
                                                        error,
                                                        resetErrorBoundary,
                                                    }) => (
                                                        <ErrorScreen
                                                            error={error}
                                                            resetErrorBoundary={resetErrorBoundary}
                                                            fullScreen
                                                        />
                                                    )}
                                                >
                                                    <ProgressBarStyle />
                                                    <ChartStyle />
                                                    <ScrollToTop />
                                                    <Router />
                                                    <ActingRoleDialog />
                                                </ErrorBoundary>
                                            </ActingRoleProvider>
                                        </ConversationsProvider>
                                    </VideoCallProvider>
                                </VideoCallLogProvider>
                            </LocationDetectionProvider>
                        </NotistackProvider>
                    </ThemeSettings>
                </ThemeProvider>
            </MotionLazyContainer>
        </CacheBuster>
    );
}
